import { clsx } from 'clsx';
import { cva } from 'class-variance-authority';
import {
  type ComponentPropsWithRef,
  type ReactNode,
  useEffect,
  useState,
} from 'react';

import s from './Input.module.css';
import { useInput } from './InputRoot.js';

export type InputLabelProps = ComponentPropsWithRef<'label'> & {
  className?: string;
  children?: ReactNode;
  htmlFor: string;
  isFloating?: boolean;
};

export const inputLabelVariants = cva(s.label, {
  variants: {
    variant: {
      default: s.defaultVariant,
      error: s.errorVariant,
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

function InputLabel({
  children,
  className,
  htmlFor,
  isFloating = true,
  ...attrs
}: InputLabelProps) {
  const { variant } = useInput();
  const [isRequired, setIsRequired] = useState(false);

  useEffect(() => {
    const field = document.getElementById(htmlFor);
    if (field) setIsRequired(field.hasAttribute('required'));
  }, [htmlFor]);

  return (
    <label
      data-is-floating={isFloating}
      data-is-required={isRequired}
      htmlFor={htmlFor}
      className={clsx(
        inputLabelVariants({
          variant,
        }),
        className,
      )}
      {...attrs}
    >
      {children}
    </label>
  );
}

export { InputLabel };
